import {
    AbacoWebModule,
    MenuItem,
    RouterReadyEvent,
    VueRouter,
    ApplicationReadyEvent,
} from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";
import { createMenu } from "./menu";
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module/index";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
// import GlobalState from "@abaco/portal-global-state/src/modules/global-state/index";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts";
import PortalGlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";
import GlobalStateModule, { MODULE_ID as GLOBAL_MODULE_ID } from "@abaco/portal-global-state/src/modules/global-state";
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from "@abaco/sso-web-module/src/abaco-module";
import FerreroFixedDashboardVuexModule from "./state";
import GoogleMapsApi from "./api/googleMapsApi";
import FieldVisitsApi from "./api/fieldVisitsApi";
import AgreementsApi from "./api/agreementsApi";
import DashboardApi from "./api/dashboardApi";

import Vue from "vue";
import { HA_UNIT } from "@abaco/crop-plan-module/src/modules/crop-plan-module/api/utils";
import NumberUtils from "@abaco/web-components/src/components/input/NumberUtils";
import SsoVuexModule from "@abaco/sso-web-module/src/abaco-module/state";

const rootPath = "/sitiagri-rest-api/api_basic";
const siticatastoApi = "/siticatasto/dbgis-servlet";

const state = new FerreroFixedDashboardVuexModule();

export const MODULE_ID = "ferrero_fixed_dashboard_module";
export default class FerreroFixedDashboardModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private router!: VueRouter;
    private ssoStore!: SsoVuexModule;

    private apiCreated = false;
    private gmApi!: GoogleMapsApi;
    private fdVsApi!: FieldVisitsApi;
    private agrmApi!: AgreementsApi;
    private dshApi!: DashboardApi;

    readonly vuexModule = state;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    menu: MenuItem[] = [];

    public dangerLimit = 40;
    public warningLimit = 60;

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);

        Vue.filter("TO_AREA_HA", (val: number, fromFormat?: string) => {
            if (fromFormat === HA_UNIT) {
                return NumberUtils.stringify(val, 4);
            }
            return NumberUtils.stringify(val / 10000, 4);
        });
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find((m) => m.id === SSO_MODULE_ID) as SSOModule | undefined;
        if (!ssoModule) {
            throw new Error("SSOModule not found!");
        }

        this.ssoStore = ssoModule.vuexModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const GoogleMapsApi = (await import("./api/googleMapsApi")).default;
        this.gmApi = new GoogleMapsApi(http);

        const FieldVisitsApi = (await import("./api/fieldVisitsApi")).default;
        this.fdVsApi = new FieldVisitsApi(http);

        const AgreementsApi = (await import("./api/agreementsApi")).default;
        this.agrmApi = new AgreementsApi(http);

        const DashboardApi = (await import("./api/dashboardApi")).default;
        this.dshApi = new DashboardApi(http);
    }

    get googleMapsApi() {
        return this.gmApi;
    }
    get fieldVisitsApi() {
        return this.fdVsApi;
    }
    get agreementsApi() {
        return this.agrmApi;
    }
    get dashboardApi() {
        return this.dshApi;
    }

    dependsOn = {
        [MapWebModule.MODULE_ID]: () => new MapWebModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [GLOBAL_MODULE_ID]: () => new GlobalStateModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
        [PortalGlobalStateModule.MODULE_ID]: () => new PortalGlobalStateModule(),
    };
}
